import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';
// import { getVistaPresupuestosInternosList, getVistaPresupuestosInternosAbiertosList } from '../../helpers/user_mv';

const state = {
    controlesStock: [],
    
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR_CONTROLES_STOCK' (state) {
        state.controlesStock = [];
    },
    'SET_CONTROLES_STOCK' (state, controlesStock) {
        state.controlesStock = controlesStock;

        // state.certificados = certificados.map( certificado => ({ 
        //     ...certificado, 
        //     _rowVariant: certificado.importeFacturado == 0 ? 'danger' : ''  
        // }) );
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getControlesStock ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONTROLES_STOCK');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            apiAxios.get('controles-stock' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_CONTROLES_STOCK', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, controlStockId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('controles-stock/' + controlStockId + '/delete')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}